//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCouponType, getUseType, getCouponStatus, getGrantType } from '@/assets/js/dict'
export default {
  created() {
    getCouponType().then(res => {
      this.couponTypeList = res
    })
    getUseType().then(res => {
      this.useTypeList = res
    })
    getCouponStatus().then(res => {
      this.couponStatusList = res
    })
    getGrantType().then(res => {
      this.grantTypeList = res
    })
  },
  data() {
    return {
      list: [],
      couponTypeList: [],
      useTypeList: [],
      couponStatusList: [],
      grantTypeList: [],
      couponVisible: false,
      userType:'',
      zhanshi:0
    }
  },
  mounted() {
    this.userType = getSession('user').currentUserType
  },
  methods: {
    // 展示弹窗
    show() {
      this.couponVisible = true;
      if(getSession('user')){
        this.getListInfo() //已登录
      }else{
        this.getCouponInfo() //未登录
      }
    },
    getCouponInfo(){
      this.$get("/pay/coupon/receive/all/list",'', function (res) {
        if (res.code == 200) {
          var newArr= res.data
          for(var i=0;i<newArr.length;i++){
            newArr[i].show=0
          }
          this.list = newArr
          this.zhanshi=0
        }
      })
    },
    //优惠券列表(登录后)
    getListInfo() {
      this.$get("/pay/coupon/receive/list",'', function (res) {
        if (res.code == 200) {
          var newArr= res.data
          for(var i=0;i<newArr.length;i++){
            newArr[i].show=0
          }
          this.list = newArr
          if(this.list.length==0){
            this.zhanshi=1
          }else{
            this.zhanshi=0
          }
        }
      })
    },
     // 展示详细信息
     showMore(index){
      var list = this.list
      if(list[index].show==1){
        list[index].show=0
      }else{
        list[index].show=1
      }
    },
    //查看优惠券
    lookCoupon(){
      this.$router.push({
        path:'/person/myCoupon'
      })
      this.couponVisible= false
      setLocal('coupon',0)
    },

    // 发布项目
    sendProject(){
      var userType = getSession('user').currentUserType
      if(userType ==2){
       
        this.$router.push({
          path:'/release/index?releaseType=1'
        })
        this.couponVisible= false
        setLocal('coupon',0)
      }
      if(userType==3){
        this.$message.info('当前身份不能操作,请切换为发包商再进行操作')
      }
    },

    // 关闭弹窗
    iconCloseCou(){
      this.couponVisible= false
      setLocal('coupon',0)
    },

    //领取优惠券
    nowGet(){
      if(getSession('user')){
        this.$post('/pay/user/coupon/receive?grantTypes=1','',function(res){
          if(res.code==200){
            this.getListInfo()
            this.zhanshi=1
          }
        })
      }else{
        this.$router.push({
          path: "/login?coupon=1",
        });
      }
    }

  }

}
